<template>
	<div :id="appointment.appointmentId"
			 v-bind:class="color"
			 class="w3-panel w3-card-2 w3-round-medium  w3-padding-small"
			 :draggable="!isStatusNoBadge(appointment.status) && !isStatusLeftConsultation(appointment.status)"
			 v-on:dragstart="onDragStart($event)">
		<div class="w3-cell w3-left w-80pc">
			<div class="w3-col flow-blue-color font-weight-bold ">
				<span>{{ appointment.appointmentTime }} - </span>
				<span>{{ appointment.physician.name }}</span>
			</div>

			<div class="w3-col">
                <span class="zero w3-show-inline-block w3-medium">
                    <b class="cursor-pointer flow-underline"
											 @click="selectPatient(appointment)">{{ appointment.patientName }}</b>
                    <span v-if="device">
                        <i class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left"
													 :title="$t('loggedIn')"></i>
                    </span>
                    <span v-if="appointment.ticket">({{ appointment.ticket }})</span>
                </span>
			</div>

			<div class="w3-col">
				<span>{{ dob }}</span>
			</div>

			<div class="w3-col">
				<span v-if="appointment.comment">{{ appointment.comment }}</span>
				<span v-else>{{ notGiven }}</span>
			</div>
		</div>
		<div class="w3-container w3-cell w3-large w3-cell-top zero w3-right  w3-center">
			<i v-if="!isStatusNoBadge(appointment.status) && !isStatusLeftConsultation(appointment.status)"
				 :id="appointment.appointmentId+'_forward'"
				 @click="forwardPatient"
				 class="fa fa-share flow-green-other-color cursor-pointer"></i><br>
			<div class=" w3-right w3-text-red"
					 v-if="appointmentStatus.maxTimeAllowedInMilli && appointmentStatus.maxTimeAllowedInMilli>0">
				<i class="fa fa-clock"></i><br>
				<b class="w3-medium">{{ timeInStatus }}</b>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import {EventBus} from "@/main";

let frc = Vue.prototype.$frc;

export default {
	name: "patientCard",
	props: ['appointment', 'statuses', 'appointmentStatus', 'notify', 'plugin'],
	data: function () {
		return {
			notGiven: this.$t("notGiven"),
			lsitems: {}
		}
	},
	mounted() {
		this.getLSitems();
	},
	computed: {
		color() {
			if (this.appointment.status === 'NoBadge') {
				return 'flow-gray-bg-color';
			} else if (this.appointment.overstay) {
				return 'w3-pale-red';
			} else if (this.notify) {
				return 'w3-khaki';
			} else if (this.isMinor === 'true') {
				return 'w3-pale-blue';
			} else {
				return 'w3-white';
			}
		},
		dob() {
			let res = Vue.getValueForKey(this.appointment.patientProperties.entry, 'birth_date');
			return res ? res : this.notGiven;
		},
		device() {
			let res = Vue.getValueForKey(this.appointment.patientProperties.entry, 'device');
			return res;
		},
		isMinor() {
			let check = Vue.getValueForKey(this.appointment.patientProperties.entry, 'isMinor');
			return check;
		},
		timeInStatus() {
			let min = Math.round(this.appointment.timeSpent / 60000);
			let hr = 0;
			let time = '';

			if (min < 0) {
				time = 0 + this.$t('m');
			} else if (min > 99) {
				hr = Math.round(min / 60);
				time = '+' + hr + this.$t('h');
			} else {
				time = min + this.$t('m');
			}
			return time;
		}
	},
	methods: {
		onDragStart: function () {
			EventBus.$emit("dragStarted", this.appointment);
		},
		forwardPatient: function () {
			EventBus.$emit("forwardPushed", this.appointment);
		},
		selectPatient: function (patient) {
			let device = this.device ? true : false;
			EventBus.$emit("dhPatientSelected", {
				id: patient.patientId,
				name: patient.patientName,
				internalIds: patient.internalIds,
				status: patient.status,
				device: device
			});
		},
		getLSitems() {
			let items = localStorage.getItem("notifyAppointments" + this.plugin);
			if (items) {
				this.lsitems = JSON.parse(items);
			}
		}
	}
}
</script>